import React from "react";
import { View, Image, StyleSheet } from "react-native";
import RNCarousel from "react-native-looped-carousel";

import Text from "../CustomText";

const Carousel = (data = []) => {
  const millis = 3000;
  const renderData = (item) => (
    <View
      style={[
        styles.card,
        {
          backgroundColor: item?.bgColor || "#E6F7EE",
          borderColor: item?.borderColor || "rgba(0, 171, 89, 0.6)",
        },
      ]}
    >
      <Image source={{ uri: item?.icon }} style={styles.icon} />
      <View style={styles.textContainer}>
        <Text newfont={true} variant="body_text_4">
          {item?.heading}
        </Text>
        <Text newfont={true} variant="caption_2">
          {item?.desc}
        </Text>
      </View>
    </View>
  );
  if (data.length === 0) return null;
  return (
    <View style={styles.container}>
      <RNCarousel
        bullets={data.length !== 1}
        bulletStyle={styles.bulletStyle}
        chosenBulletStyle={styles.chosenBulletStyle}
        bulletsContainerStyle={styles.bulletsContainerStyle}
        style={styles.carousel}
        autoplay={true}
        delay={millis}
        pageInfo={false}
      >
        {data?.map(renderData)}
      </RNCarousel>
    </View>
  );
};

const styles = StyleSheet.create({
  container: { marginHorizontal: 8 },
  bulletStyle: {
    height: 4,
    width: 4,
    backgroundColor: "#D9D9D9",
    borderRadius: 50,
    marginHorizontal: 3,
    borderWidth: 0,
  },
  chosenBulletStyle: {
    height: 4,
    width: 16,
    backgroundColor: "#E40046",
    marginHorizontal: 3,
    borderRadius: 2,
  },
  bulletsContainerStyle: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    width: "100%",
    top: 100,
  },
  carousel: {
    // width: "110%",
    height: 100,
    marginVertical: 8,
    // alignItems: "center",
    justifyContent: "center",
  },
  card: {
    backgroundColor: "#E6F7EE",
    borderRadius: 10,
    padding: 16,
    flexDirection: "row",
    flex: 1,
    borderColor: "rgba(0, 171, 89, 0.6)",
    borderWidth: 1,
    overflow: "hidden",
  },
  icon: { height: 30, width: 30, marginRight: 14 },
  textContainer: { maxWidth: "80%" },
});

export default Carousel;
